import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useUnifiedAuth } from '../../context/UnifiedAuthContext';

/**
 * JoinCourse - Redirects to welcome page with invite code
 * If not authenticated, opens auth modal
 * If authenticated, fills code in dashboard join form
 */
function JoinCourse() {
  const { inviteCode } = useParams();
  const navigate = useNavigate();
  const { isAuthenticated, loading } = useUnifiedAuth();
  
  useEffect(() => {
    if (loading) return;
    
    if (isAuthenticated) {
      // Authenticated: Go to dashboard with code pre-filled
      navigate(`/student/dashboard?joinCode=${inviteCode}`, { replace: true });
    } else {
      // Not authenticated: Go to welcome with auth modal
      navigate(`/?auth=true&joinCode=${inviteCode}`, { replace: true });
    }
  }, [inviteCode, isAuthenticated, loading, navigate]);
  
  // Show loading while redirecting
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-primary-500 border-t-transparent mx-auto mb-4" />
        <p className="text-gray-600 dark:text-gray-400">Lade Einladung...</p>
      </div>
    </div>
  );
}

export default JoinCourse;
